import { useEoValue } from '~/src/hooks/useEoState'
import { useTranslations } from '~/src/hooks/useTranslations'
import { BRAND_STATE } from '~/src/stores/brand'
import { FIRM_SELECTOR } from '~/src/stores/firm'
import { IS_ON_MARKETPLACE_PAGE_SELECTOR } from '~/src/stores/layout'

const NewsLetterSwitchLabel = () => {
  const { t } = useTranslations()
  const brand = useEoValue(BRAND_STATE)
  const firm = useEoValue(FIRM_SELECTOR)
  const isOnMarketplacePage = useEoValue(IS_ON_MARKETPLACE_PAGE_SELECTOR)

  if (isOnMarketplacePage) {
    return <>{`${t('profile.opt_in_merchant')} ${brand?.name}`}</>
  }

  return <>{`${t('profile.opt_in_merchant')} ${firm?.name}`}</>
}

export default NewsLetterSwitchLabel
